import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { ResearchArticle } from 'site-modules/editorial/pages/research-article/research-article';

function ResearchDefaultUI({ content, articleCategory, articleId, splat }) {
  if (!content) {
    return null;
  }

  return <ResearchArticle content={content} slug={articleCategory} splat={splat} articleId={articleId} />;
}

ResearchDefaultUI.propTypes = {
  articleCategory: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
  splat: PropTypes.string,
  content: CmsEntities.Content,
};

ResearchDefaultUI.defaultProps = {
  splat: undefined,
  content: null,
};

export const ResearchDefault = connectToModel(ResearchDefaultUI, {
  content: bindToContent(({ articleCategory, articleId, splat }) =>
    getResearchArticleIndexPath(articleCategory, articleId, splat)
  ),
});
